import Transformer from './Transformer';

class itemTransformOffersV4 extends Transformer {
    transform(model) {
        return this.normalizeItem(model);
    }

    /**
     * Desenvuelve el contenedor de respuesta de la API v4 sin normalizar el texto.
     * Se usa cuando ADS está habilitado: la rama ADS de CardNew lee los textos de traducción en
     * forma de objeto { text1, text2, text3 }, que coincide directamente con la respuesta de la API v4.
     * @param {object} response - Respuesta sin procesar de la API v4 { data: [...] }
     * @returns {Array}
     */
    getItems(response) {
      const data = (response && response.data) ? response.data : [];
      const normalize = data.map(item => this.normalizeItem(item));
      return {offers:normalize};
    }

    /**
     * Elimina los campos exclusivos de v4 que no se consumen posteriormente.
     * La traducción se pasa sin cambios (formato de objeto).
     * @param {object} item
     * @returns {object}
     */
    normalizeItem(item) {
        if (!item || typeof item !== 'object') {
            return {};
        }
        const { producttype, price, assets, translation, _links } = item;
        return {
            producttype,
            price,
            assets,
            translation,
            _links,
        };
    }
}

export default new itemTransformOffersV4();



// WEBPACK FOOTER //
// ./src/requests/transformers/itemTransformOffersV4.js